import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const ChangeVolumeRequestSchema = z.object({
  volumeNumber: z.coerce
    .number()
    .int('Must be a whole number')
    .min(0, 'Number must be at least 0')
    .max(15, 'Number must be at most 15'),
});

export type ChangeVolumeRequest = z.infer<typeof ChangeVolumeRequestSchema>;

export function ChangeVolumeForm({ onSubmit, onChancel }: any) {
  const form = useForm<ChangeVolumeRequest>({
    resolver: zodResolver(ChangeVolumeRequestSchema),
    defaultValues: {
      volumeNumber: undefined,
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="volumeNumber"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Volume</FormLabel>
              <FormControl>
                <Input
                  autoComplete="off"
                  inError={!!form.formState.errors.volumeNumber}
                  placeholder="Volume number"
                  min={0}
                  max={15}
                  type="number"
                  {...field}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message || ''}</FormMessage>
            </FormItem>
          )}
        />

        <div className="flex gap-4 justify-end">
          <Button type="button" variant="outline" onClick={onChancel}>
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </div>
      </form>
    </Form>
  );
}
